<template>
  <div>
    <v-dialog v-model="open" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small outlined color="primary" v-bind="attrs" v-on="on" :disabled="disabled">
          Importar planilha
        </v-btn>
      </template>

      <v-card>
        <v-toolbar elevation="0">
          <v-card-title class="ml-0 pl-1">
            Importar planilha
          </v-card-title>

          <v-spacer />

          <v-btn icon @click="open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          Deseja realmente importar o arquivo para a conta selecionada? Verifique todos os dados antes de continuar

          <slot></slot>
        </v-card-text>

        <v-card-text>
          <v-select menu-props="auto" hide-details single-line solo color="primary"
            label="Selecione uma das opções antes de continuar" dense v-model="scheduleType" :items="listActions">
          </v-select>
        </v-card-text>

        <v-card-text>
          <VueFileAgent ref="vueFileAgent" :theme="'list'" :multiple="true" :deletable="true" :meta="true"
            :accept="'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
            :maxSize="'10MB'" :maxFiles="1" :helpText="'Escolher o arquivo'" :errorText="{
              type: 'Invalid file type. Only xls or xlsx Allowed',
              size: 'Files should not exceed 10MB in size',
            }" @select="filesSelected($event)" @beforedelete="onBeforeDelete($event)" @delete="fileDeleted($event)"
            v-model="fileRecords"></VueFileAgent>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="cancel">
            Cancelar
          </v-btn>
          <v-btn :loading="loading" color="primary" :disabled="!fileRecordsForUpload.length" @click="submit">
            Enviar arquivo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
  
<script>
import { mapState } from 'vuex'
import { handleResponseError } from '@/api/handleError'
import { get } from 'lodash'

export default {
  name: 'LocationXlsImportModal',
  props: {
    locationName: String,
    accountNameXls: String,
    bulk: {
      type: Boolean,
    },
    filters: Object,
    disabled: Boolean,
    permission: Boolean,
  },
  computed: {
    ...mapState({
      location: state => state.locations.location,
      uploadLocationXlsFile: state => state.locations.uploadLocationXlsFile,
      uploadLocationXlsFileError: state => state.locations.uploadLocationXlsFileError,

      listActions() {
        let options = [
          { text: 'Atualizar locais', value: 'TYPE_UPDATE_LOCATIONS_BY_FILE' },
        ]
        if (this.permission) {
          options.push({ text: 'Criar locais', value: 'TYPE_STORE_LOCATIONS_BY_FILE' })
        }
        return options
      },
    })
  },
  watch: {
    uploadLocationXlsFile(current, previous) {
      if (current && current !== previous) {
        this.open = false
        this.loading = false
        const taskId = get(current, 'tasks[0].id')
        if (taskId) {
          this.$router.push(`/task/${taskId}`)
        } else {
          this.showNotification('Não foi possível salvar o arquivo.', 'red darken-2')
        }
      }
    },
    uploadLocationXlsFileError(error) {
      this.loading = false
      if (error) {
        this.showNotification(handleResponseError(error, 'Não foi possível salvar o arquivo'), 'red darken-2')
      }
    }
  },
  data: () => ({
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    fileRecords: [],
    loading: false,
    uploadUrl: '/mediaitem',
    uploadHeaders: { 'X-Test-Header': 'vue-file-agent' },
    fileRecordsForUpload: [],
    scheduleType: '',
    open: false,
  }),
  methods: {
    cancel: function () {
      this.open = false
    },
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    submit: function () {
      const params = {
        account: this.accountNameXls
      }
      let formData = new FormData()
      formData.append('params', JSON.stringify(params))
      formData.append('_method', 'POST')

      if (!this.scheduleType) {
        this.scheduleType = 'TYPE_UPDATE_LOCATIONS_BY_FILE'
      }

      if (this.fileRecordsForUpload[0].file) {
        formData.append('file', this.fileRecordsForUpload[0].file)
        formData.append('schedule_type', this.scheduleType)
      }

      this.loading = true
      this.$store.dispatch('locations/uploadLocationXlsFile', formData)
    },
    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
    filesSelected: function (fileRecordsNewlySelected) {
      let validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
    },
    onBeforeDelete: function (fileRecord) {
      let i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1);
        let k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
        if (confirm('Are you sure you want to delete?')) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        }
      }
    },
    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
    },
  },
}
</script>
  
<style></style>
  